module.exports = __webpack_public_path__ + "img/musicRobot.15ea9ddc.png";